import { TrafficLightSummary } from '@/components/TrafficLightSummary'

export function SecurityTrafficLight({ posture, onSectionClick }) {
  return (
    <TrafficLightSummary
      title="Security at a glance"
      posture={posture}
      onSectionClick={onSectionClick}
    />
  )
}
